import styled, { css } from "styled-components";
import { Link } from "wouter";

import { SPACING } from "../../utils/constants";

export const LockLine = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  white-space: nowrap;

  svg {
    font-size: var(--text-md);
  }
`;

export const inlineLinkStyle = css`
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

export const OpenLink = styled(Link)`
  ${inlineLinkStyle}
`;
